import React, { Component } from 'react';
import Header from '../../../Containers/Header/Header';
import Footer from '../../../Containers/Footer';
import PageTopMenu from '../../../Containers/PageTopMenu';
import VocabRestultPage from '../Vocab/Result';

class VocabTestResult extends Component {
    render() {
        return (
            <div className="beaconWrapper">
                <Header />
                <div className="allconWrapper">
                  <div className="contentsWrapper">
                      <h2 className="screenOut">오늘의 Vocabulary 시험</h2>
                      <PageTopMenu />
                      <div className="pageContents">
                          <VocabRestultPage categoryName="vocabulary"/>
                      </div>
                  </div>
                  <Footer />
                </div>
            </div>
        );
    }
}

export default VocabTestResult;



// WEBPACK FOOTER //
// ./src/components/Pages/Student/Exam/Result.js